import { createFileRoute } from '@tanstack/react-router'
import { StaffPendidikan } from '../../../../components/StaffPendidikan'

export const Route = createFileRoute('/desa/$slug/dashboard/pendidikan')({
  component: () => {
    const { desaId } = Route.useRouteContext() as { desaId: string }
    if (!desaId) return null
    return <StaffPendidikan desaId={desaId} />
  },
})
